import common from "../common";
import {saveAs} from "file-saver";

/**
 * Returns translated string for given key
 * @param key
 * @returns {*|string}
 */
export function translate(key) {
    let str = key || "";
    if (str.length > 0) {
        const split = str.split(".");
        split.push(window.__language ? window.__language : common.config.language);
        let i, length, t = common.strings;
        for (i = 0, length = split.length; i < length; ++i) {
            t = t[split[i]];
            if (!t) break;
        }
        i === split.length && (str = t);
    }
    return str;
}

/**
 * Creates a button with a label
 * @param type
 * @param labelCopy
 * @returns {*}
 */
export function createLabelButton(type = "regular", labelCopy = "") {

    const button = P3.Button.create(
        P3.assets.texture("btn_" + type + "_out"),
        P3.assets.texture("btn_" + type + "_over"),
        P3.assets.texture("btn_" + type + "_down")
    );

    button.clickSoundName = "sfx_click";
    button.overSoundName = "sfx_rollover";

    button.label = new PIXI.Text(labelCopy,
        {fontFamily: "oswaldregular", fontSize: 36, fill: 0x0, fontWeight: "bold"});
    button.label.anchor.set(0.5);
    button.label.y = 2;
    button.animation.addChild(button.label);

    return button;

}

/**
 * @param texture
 * @param callback
 */
export function saveImage(texture, callback) {
    if (window.parent && window.parent.saveImageToDevice) {
        const data = common.renderer.plugins.extract.base64(texture);
        window.parent.saveImageToDevice(data, callback, (error) => console.error(error));
    } else {
        const data = common.renderer.plugins.extract.canvas(texture);
        data.toBlob(function (blob) {
            saveAs(blob, common.config.screenshot_name + ".png");
        }, "image/png");
        callback && callback.call();
    }
}

//array fill polyfill
(function () {
    if (!Array.prototype.fill) {
        Object.defineProperty(Array.prototype, 'fill', {
            value: function (value) {

                // Steps 1-2.
                if (this == null) {
                    throw new TypeError('this is null or not defined');
                }

                var O = Object(this);

                // Steps 3-5.
                var len = O.length >>> 0;

                // Steps 6-7.
                var start = arguments[1];
                var relativeStart = start >> 0;

                // Step 8.
                var k = relativeStart < 0 ?
                    Math.max(len + relativeStart, 0) :
                    Math.min(relativeStart, len);

                // Steps 9-10.
                var end = arguments[2];
                var relativeEnd = end === undefined ?
                    len : end >> 0;

                // Step 11.
                var finalValue = relativeEnd < 0 ?
                    Math.max(len + relativeEnd, 0) :
                    Math.min(relativeEnd, len);

                // Step 12.
                while (k < finalValue) {
                    O[k] = value;
                    k++;
                }

                // Step 13.
                return O;
            }
        });
    }

})();

// array flat polyfill from - https://codepen.io/chungguo/pen/xvXeMR
(function () {
    if (!Array.prototype.flat) {
        Object.defineProperty(Array.prototype, 'flat', {
            value: function () {
                return this.reduce((acc, cur, index) => {
                    return Array.isArray(cur) ? acc.concat(flat(cur)) : acc.concat(cur);
                }, []);
            }
        });
    }
})();

// fixing bug with animated sprite
(function () {
    /**
     * @param deltaTime
     */
    PIXI.AnimatedSprite.prototype.update = function (deltaTime) {
        if (!this._playing)
            return;

        const elapsed = this.animationSpeed * deltaTime;
        const previousFrame = this.currentFrame;
        if (this._durations !== null) {
            let lag = this._currentTime % 1 * this._durations[this.currentFrame];
            lag += elapsed / 60 * 1000;
            while (lag < 0) {
                this._currentTime--;
                lag += this._durations[this.currentFrame];
            }
            const sign = Math.sign(this.animationSpeed * deltaTime);
            this._currentTime = Math.floor(this._currentTime);
            while (lag >= this._durations[this.currentFrame]) {
                lag -= this._durations[this.currentFrame] * sign;
                this._currentTime += sign;
            }
            this._currentTime += lag / this._durations[this.currentFrame];
        } else {
            this._currentTime += elapsed;
        }
        if (this._currentTime < 0 && !this.loop) {
            this.gotoAndStop(0);
            if (this.onComplete) {
                this.onComplete();
            }
        } else if (this._currentTime >= this._textures.length && !this.loop) {
            this.gotoAndStop(this._textures.length - 1);
            if (this.onComplete) {
                this.onComplete();
            }
        } else if (previousFrame !== this.currentFrame) {
            if (this.loop && this.onLoop) {
                if (this.animationSpeed > 0 && this.currentFrame < previousFrame) {
                    this.onLoop();
                } else if (this.animationSpeed < 0 && this.currentFrame > previousFrame) {
                    this.onLoop();
                }
            }
            this.updateTexture();
        }
    }
})();

(function () {
    P3.NewCamera.prototype.update = function () {

        this._target && this._position.set(this._target.x * this._parallax.x, this._target.y * this._parallax.y);
        this._clampToBounds(this._position);

        for (let i = 0; i < this._layers.length; ++i) {
            const layer = this._layers[i];
            const position = new PIXI.Point(this._target.x * layer.parallax.x, this._target.y * layer.parallax.y);
            layer.view.pivot.set(this.focus.x + position.x, this.focus.y + position.y);
            layer.view.position.set(layer.view.pivot.x + this.offset.x + (this._position.x * -layer.parallax.x),
                layer.view.pivot.y + this.offset.y + (this._position.y * -layer.parallax.y));
            layer.view.scale.set(this.zoom, this.zoom);
        }

    }
})();

(function () {
    /**
     * Will return a one-dimensional array containing the pixel data of the entire texture in RGBA
     * order, with integer values between 0 and 255 (included).
     *
     * @param {PIXI.DisplayObject|PIXI.RenderTexture} target - A displayObject or renderTexture
     *  to convert. If left empty will use the main renderer
     * @return {Uint8Array} One-dimensional array containing the pixel data of the entire texture
     */

    PIXI.Extract.prototype.pixel = function (target, point) {

        const renderer = this.renderer;
        let resolution;
        let frame;
        let renderTexture;
        let generated = false;
        if (target) {
            if (target instanceof PIXI.RenderTexture) {
                renderTexture = target;
            } else {
                renderTexture = this.renderer.generateTexture(target);
                generated = true;
            }
        }
        if (renderTexture) {
            resolution = renderTexture.baseTexture.resolution;
            frame = renderTexture.frame;
            // bind the buffer
            renderer.renderTexture.bind(renderTexture);
        } else {
            resolution = renderer.resolution;
            frame = TEMP_RECT;
            frame.width = renderer.width;
            frame.height = renderer.height;
            renderer.renderTexture.bind(null);
        }
        const width = frame.width * resolution;
        const height = frame.height * resolution;
        const webglPixels = new Uint8Array(4);
        // read pixels to the array
        const gl = renderer.gl;
        gl.readPixels(point.x * resolution, point.y * resolution, 1, 1, gl.RGBA, gl.UNSIGNED_BYTE, webglPixels);
        if (generated) {
            renderTexture.destroy(true);
        }
        PIXI.Extract.arrayPostDivide(webglPixels, webglPixels);
        return webglPixels;

    }
})();
(function () {
    const tempPoint = new PIXI.Point();
    PIXI.Sprite.prototype.getColorByPoint = function (point) {
        this.worldTransform.applyInverse(point, tempPoint);

        const width = this._texture.orig.width;
        const height = this._texture.orig.height;
        const x1 = -width * this.anchor.x;
        let y1 = 0;

        let flag = false;

        if (tempPoint.x >= x1 && tempPoint.x < x1 + width) {
            y1 = -height * this.anchor.y;

            if (tempPoint.y >= y1 && tempPoint.y < y1 + height) {
                flag = true;
            }
        }

        if (!flag) {
            return [0, 0, 0, 0];
        }

        // bitmap check

        const tex = this.texture;
        const baseTex = this.texture.baseTexture;
        if (!baseTex.colormap) {
            if (!genColorMap(baseTex)) {
                return [0, 0, 0, 0];
            }
        }

        const colormap = baseTex.colormap;
        const data = colormap.data;
        const res = baseTex.resolution;
        // this does not account for rotation yet!!!
        let dx = Math.round((tempPoint.x - x1 + tex.frame.x) * res);
        let dy = Math.round((tempPoint.y - y1 + tex.frame.y) * res);
        let num = dx + dy * colormap.width;
        return [data[num * 4], data[num * 4 + 1], data[num * 4 + 2], data[num * 4 + 3]];

        function genColorMap(baseTex) {
            if (!baseTex.resource) {
                //renderTexture
                return false;
            }
            const imgSource = baseTex.resource.source;
            // console.log(imgSource);
            let canvas = null;
            if (!imgSource) {
                return false;
            }
            let context = null;
            if (imgSource.getContext) {
                canvas = imgSource;
                context = canvas.getContext('2d');
                //console.log(context);
            }

            const w = canvas.width, h = canvas.height;
            baseTex.colormap = context.getImageData(0, 0, w, h);
            return true;
        }
    }
})();

/*
(function () {
    P3.utils.TWEEN.Group.prototype.time = 0;
    P3.utils.TWEEN.Group.prototype.update = function (time, preserve) {
        this.time += window.tweendt;

        var tweenIds = Object.keys(this._tweens);
        if (tweenIds.length === 0) {
            return false;
        }
        time = time !== undefined ? time : this.time;
        while (tweenIds.length > 0) {
            this._tweensAddedDuringUpdate = {};

            for (var i = 0; i < tweenIds.length; i++) {
                var tween = this._tweens[tweenIds[i]];
                if (tween && tween.update(time) === false) {
                    tween._isPlaying = false;
                    if (!preserve) {
                        delete this._tweens[tweenIds[i]];
                    }
                }
            }
            tweenIds = Object.keys(this._tweensAddedDuringUpdate);
        }

        return true;
    };

    P3.utils.TWEEN.Tween.prototype.start = function (time) {
        this._group.add(this);

        this._isPlaying = true;

        this._onStartCallbackFired = false;

        this._startTime = time !== undefined ? typeof time === 'string' ? this._group.time + parseFloat(time) : time : this._group.time;
        this._startTime += this._delayTime;

        for (var property in this._valuesEnd) {
            if (this._valuesEnd[property] instanceof Array) {
                if (this._valuesEnd[property].length === 0) {
                    continue;
                }
                this._valuesEnd[property] = [this._object[property]].concat(this._valuesEnd[property]);

            }
            if (this._object[property] === undefined) {
                continue;
            }

            this._valuesStart[property] = this._object[property];

            if ((this._valuesStart[property] instanceof Array) === false) {
                this._valuesStart[property] *= 1.0;
            }
            this._valuesStartRepeat[property] = this._valuesStart[property] || 0;
        }

        return this;
    };
})();
 */